import {memo, useEffect} from "react";
import styles from "./modal.module.scss";
import { Dialog } from "@mui/material";
import Svg from "@source/components/UI/svg/svg";
import closeIcon from "@source/assets/imgs/close.svg";
import appStore from "@store/appStore";

export default memo((props: ModalProps) => {
  const {children, open, close, className, maxWidth=600, height, overwriteClassName} = props;
  const finalClassName = overwriteClassName ? overwriteClassName : `${styles.modal} ${className}`
  return(
    <Dialog
      open={!!open}
      PaperProps={{
        style: {
          position: 'relative',
          width: appStore.getIsMobile() ? '95%' : '100%',
          maxWidth: maxWidth, 
          borderRadius: 16, 
          margin: appStore.getIsMobile() ? '0 4px' : '0 16px',
          backgroundColor: '#fff', 
          overflow: 'unset',
          height: height,
        }
      }}>
        <div className={finalClassName}>
          {children}
        </div>

        {close
          ? <div onClick={() => close()} className={styles.modal_close}>
              <Svg src={closeIcon} width={12} height={12} color="#333"/>
            </div>
          : <></>}
    </Dialog>
  )
})

interface ModalProps {
  /** Modal inner */
  children: JSX.Element | string,

  /** Modal open status
   * @default false
   */
  open: boolean,

  /** close event handler */
  close?: () => void,

  /** Modal inner maxWidth */
  maxWidth?: number | string,

  className?: string,
  overwriteClassName?: string,

  /** Modal inner height */
  height?: number | string,
}